var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('TopMenu',{attrs:{"msg":"Информация по пациенту: "}}),_c('PatientCard',{attrs:{"mppId":_vm.mppId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }